var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$s.Loading},[_c('svg',{class:[
			_vm.$s.Spinner,
			_vm.$s[("size_" + _vm.size)] ],attrs:{"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{class:[
				_vm.$s.Circle,
				_vm.$s[("size_" + _vm.size)] ],attrs:{"fill":"none","stroke-linecap":"round","cx":"8","cy":"8","r":"7"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }